"use client";

import { BuilderTypes } from "@/api/AppApi/common-interfaces/api-enums";
import ProductsWithFilters from "../common/produts-with-filters/ProductsWithFilters";
import { IBrand } from "@/api/AppApi/services/home/interfaces/IBrands";
import BrandsCarousel from "../../common-builder/brand/BrandsCarousel";

interface Props {
  brands: IBrand[];
  searchParams: { [key: string]: string };
  brandID?: string;
  PixeListName: string;
}

const BrandDetailsBlackBox: React.FC<Props> = ({
  brands,
  searchParams,
  brandID,
  PixeListName,
}) => {
  const SearchParams = { ...searchParams };
  if (brandID) {
    SearchParams["brands"] = brandID; //for the product filter
    SearchParams["brand_id"] = brandID; // for the filter builder
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
      {brands?.length > 0 && (
        <BrandsCarousel index={0} type={BuilderTypes.brands} data={brands} />
      )}

      <ProductsWithFilters
        searchParams={{ ...SearchParams }}
        isCategoryPage
        PixeListName={PixeListName}
        PixeListId={brandID || ""}
      />
    </div>
  );
};
export default BrandDetailsBlackBox;
